import React, { ReactNode } from 'react'
import UIHeader from '../components/UI/UIHeader'
import UISIdeBar from '../components/UI/UISIdeBar'

interface MyComponentProps {
  children: ReactNode
}

const Layout: React.FC<MyComponentProps> = ({ children }) => {
  return (
    <>
      <div className={'flex h-full w-full'}>
        {/* sidebar */}
        <UISIdeBar />

        {/* content */}
        <div className={'flex-col w-full bg-gray1'}>
          <div className={'flex-col w-full p-5 h-[88vh] '}>
            <UIHeader />
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout
